import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://252signal.com';

interface SEOProps {
  title: string;
  description: string;
  path: string;
  ogType?: 'website' | 'article' | 'profile';
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
  noindex?: boolean;
}

/**
 * Per-route head tags. Renders unique <title>, meta description,
 * canonical, og:* and optional JSON-LD per page. Overrides the
 * sitewide defaults baked into index.html for JS-executing crawlers.
 */
const SEO = ({ title, description, path, ogType = 'website', jsonLd, noindex }: SEOProps) => {
  const url = `${SITE_URL}${path}`;
  const truncatedDesc = description.length > 160 ? description.slice(0, 157) + '…' : description;
  const ldArray = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={truncatedDesc} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={truncatedDesc} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={ogType} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={truncatedDesc} />
      {noindex ? <meta name="robots" content="noindex, nofollow" /> : null}
      {ldArray.map((ld, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(ld)}</script>
      ))}
    </Helmet>
  );
};

export default SEO;
